import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, Grid, Typography } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import React from 'react'
import i18n from 'simple-react-i18n'
import FormContributorPanel from '../phase1/diagnostic/FormContributorPanel'
import { useParams } from 'react-router'
import { shallowEqual, useSelector } from 'react-redux'
import DocumentsPanel from '../phase1/diagnostic/DocumentsPanel'
import ActivitiesPanel from '../phase1/diagnostic/ActivitiesPanel'
import FormResourcePanel from '../phase1/campaign/FormResourcePanel'
import FormInstallationPanel from '../phase1/campaign/FormInstallationPanel'

const DiagnosisCard = () => {
    const {
        diagnostic,
    } = useSelector(store => ({
        diagnostic: store.PgsseReducer.diagnostic,
    }), shallowEqual)

    const { idDiagnostic } = useParams()

    const campaigns = diagnostic.link_campaigns

    // TODO: revoir règles de gestion
    const resourcesCampaings = campaigns
    const installationCampaings = campaigns

    const sections = [
        {
            title: i18n.contributors,
            component:
                <FormContributorPanel
                    idDiagnostic={parseInt(idDiagnostic)}
                    data={diagnostic.link_forms}
                    readMode
                />,
        },
        {
            title: i18n.document,
            component:
                <DocumentsPanel
                    link_docs={diagnostic.link_docs}
                    readMode
                />,
        },
        {
            title: i18n.activities,
            component:
                <ActivitiesPanel
                    link_activities={diagnostic.link_activities}
                    readMode
                />,
        },
    ]

    return (
        <Card sx={{ width: '100%' }}>
            <CardTitle title={i18n.diagnosticConsultation}/>
            <CardContent>
                <Grid container direction={'column'} spacing={2}>
                    <Card>
                        <CardTitle title={i18n.resources}/>
                        <CardContent>
                            <Grid container direction={'column'} spacing={2}>
                                {resourcesCampaings?.length
                                    ? (
                                        resourcesCampaings.map((campaign) => (
                                            <Accordion key={campaign.idCampaign}>
                                                <AccordionSummary>{campaign.name || i18n.unknown}</AccordionSummary>
                                                <AccordionDetails sx={{ padding: 0 }}>
                                                    <FormResourcePanel
                                                        idDiagnostic={parseInt(idDiagnostic)}
                                                        idCampaign={parseInt(campaign.idCampaign)}
                                                        link_stations={campaign.link_stations}
                                                        readMode
                                                    />
                                                </AccordionDetails>
                                            </Accordion>
                                        ))
                                    )
                                    : (<Typography>{i18n.noDiagnostic}</Typography>)
                                }
                            </Grid>
                        </CardContent>
                    </Card>

                    <Card>
                        <CardTitle title={i18n.installations}/>
                        <CardContent>
                            <Grid container direction={'column'} spacing={2}>
                                {installationCampaings?.length
                                    ? (
                                        installationCampaings.map((campaign) => (
                                            <Accordion key={campaign.idCampaign}>
                                                <AccordionSummary>{campaign.name}</AccordionSummary>
                                                <AccordionDetails sx={{ padding: 0 }}>
                                                    <FormInstallationPanel
                                                        idDiagnostic={parseInt(idDiagnostic)}
                                                        idCampaign={parseInt(campaign.idCampaign)}
                                                        link_stations={campaign.link_stations}
                                                        readMode
                                                    />
                                                </AccordionDetails>
                                            </Accordion>
                                        ))
                                    )
                                    : (<Typography>{i18n.noDiagnostic}</Typography>)
                                }
                            </Grid>
                        </CardContent>
                    </Card>

                    {sections.map((section) => (
                        <Accordion key={section.title}>
                            <AccordionSummary>{section.title}</AccordionSummary>
                            <AccordionDetails sx={{ padding: 0 }}>
                                {section.component}
                            </AccordionDetails>
                        </Accordion>
                    ))}

                </Grid>
            </CardContent>
        </Card>
    )
}

export default DiagnosisCard
